export default "__VITE_ASSET__BFEDadyp__"